"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
const RadioGroup_1 = __importDefault(require("./RadioGroup"));
const RadioLabelDescription_1 = __importDefault(require("./RadioLabelDescription"));
const RadioComponent = (0, react_1.forwardRef)(({ checked, children, className, disabled, groupId, groupIndex, onChange, readOnly, tile, value, ...props }, ref) => {
    const radioId = `${groupId}--${groupIndex}`;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "usa-radio", children: [(0, jsx_runtime_1.jsx)("input", { ref: ref, defaultChecked: checked, className: (0, uswds_react_utils_1.createClassString)('usa-radio__input', tile && 'usa-radio__input--tile', className), disabled: disabled, id: radioId, name: groupId, onChange: onChange
                    ? (e) => {
                        if (e.target.checked) {
                            onChange(value || children);
                        }
                    }
                    : undefined, readOnly: readOnly, type: "radio", ...props }), (0, jsx_runtime_1.jsx)("label", { className: "usa-radio__label", htmlFor: radioId, children: children })] }));
});
const Radio = Object.assign(RadioComponent, { Group: RadioGroup_1.default, LabelDescription: RadioLabelDescription_1.default });
exports.default = Radio;
